import { ErrorBoundary } from 'components/common/error-boundary';
import { SidebarNavigationTrigger } from 'components/main/sidebar/nav-trigger';
import { useActiveRoute } from 'hooks/useActiveRoute';
import { useNavSections } from 'hooks/useNavSections';
import { useNavigate } from 'react-router-dom';

const COMPONENT_NAME = 'AdminSections';

export const AdminSections = () => {
  const navigate = useNavigate();
  const { section: activeSection } = useActiveRoute();
  const { adminSections } = useNavSections();

  return (
    <ErrorBoundary identifier={COMPONENT_NAME}>
      {adminSections
        .filter((s) => !s.invisible)
        .map((s, i) => {
          return (
            <SidebarNavigationTrigger
              key={`admin-section-${i}`}
              label={s.label}
              icon={<s.icon />}
              active={activeSection === s.value}
              onClick={() => {
                const defaultSubsection = s.subsections?.find(
                  (ss) => ss.default
                );
                navigate(defaultSubsection?.to ?? s.to);
              }}
            />
          );
        })}
    </ErrorBoundary>
  );
};
